import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import Home from "./pages/home/Home";
import { Route, Routes } from "react-router-dom";
import ProjectDetails from "./pages/projects/ProjectDetails";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./pages/404/NotFound";
import Contact from "./pages/contact/Contact";
import About from "./pages/about/About";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects/:slug" element={<ProjectDetails />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ScrollToTop />
    </ThemeProvider>
  );
};

export default App;
